





















import { Component, mixins, namespace, Prop } from 'nuxt-property-decorator'
import debounce from 'lodash/debounce'
import MixinGeneral from '~/assets/mixins/general'

const siteStore = namespace('site')

interface ISectionBlock {
  title: string
  code: string
}

@Component({
  components: {},
})
export default class ComponentPageProductsIdSectionMenu extends mixins(
  MixinGeneral
) {
  @Prop({ type: String, default: null }) readonly activeBlock!: string | null
  @Prop({ type: Boolean, default: false }) readonly isStoresHidden!: false
  @Prop({ type: Array, default: () => [] }) readonly items!: ISectionBlock[]
  @siteStore.Getter('getFixedHeaderHeight')
  readonly getFixedHeaderHeight!: number

  @siteStore.Getter('getFixedHeaderHeight')
  readonly fixedHeaderHeight!: number | null

  private get itemsRender(): ISectionBlock[] {
    if (!this.isStoresHidden) {
      return this.items
    }
    return this.items.filter((item) => {
      return item.code !== 'stores'
    })
  }

  private goTo(code: string) {
    this.$emit('goTo', code)
  }

  private get fixedFilterOffset() {
    return this.fixedHeaderHeight || 0
  }

  private get filtersStyle() {
    return { top: `${this.fixedFilterOffset}px` }
  }

  private refWrapper: HTMLElement | null = null

  private addFixedClass() {
    if (this.refWrapper) {
      this.refWrapper.classList.toggle(
        this.$style.fixed,
        window.pageYOffset > (this.$el as HTMLElement).offsetTop
      )
    }
  }

  private debouncedAddFixedClass = debounce(this.addFixedClass, 125)

  private mounted() {
    this.refWrapper = this.$refs.wrapper as HTMLElement | null
    if (this.refWrapper) {
      window.addEventListener('scroll', this.debouncedAddFixedClass)
    }
  }

  private beforeDestroy() {
    window.removeEventListener('scroll', this.debouncedAddFixedClass)
  }
}
